export default {
  newInstance (tool) {
    return {
      createCfg (myCfg, readonly = false) {
        const cfg = {
          // 如果需要提交表单，则此参数必传
          apiMethod: undefined,

          // 选填，如果你在Modalx里面使用了Tabs，这里就必传
          tabCount: 0,

          // 如果你在Modalx里面使用了Tabs，你需要手动绑定到Tabs组件上
          tabIndex: 0,

          // 此文件内所使用的参数，你可以通过myCfg进行覆盖
          visible: false,
          waiting: true,
          submitting: false,
          width: '520px',
          readonly,
          errorText: undefined,
          successTip: '操作成功',
          handleSubmitData: () => ({}) // return的内容作为apiMethod的请求数据

          // 其它（antd组件的参数，你可以通过myCfg传进来）
        }

        return Object.assign(cfg, myCfg)
      },
      showAndWait (cfg) {
        cfg.errorText = undefined
        cfg.submitting = false
        cfg.waiting = true
        cfg.visible = true
        cfg.tabIndex = 0
      },
      setData (cfg, res, handler) {
        tool.wrapResponse(res).then(() => {
          if (typeof handler === 'function') {
            handler(res)
          }
        }).catch(() => {
          cfg.errorText = tool.getResponseError(res)
        })
      },
      waited (cfg) {
        cfg.waiting = false
      },
      hide (cfg) {
        cfg.visible = false
      },
      show (cfg) {
        cfg.errorText = undefined
        cfg.submitting = false
        cfg.waiting = false
        cfg.visible = true
        cfg.tabIndex = 0
      },
      check (cfg, form) {
        return new Promise((resolve) => {
          if (form) {
            form.validateFields((isError, values) => {
              console.log(values)
              if (!isError) {
                cfg.submitting = true
              }
              resolve(isError)
            })
          } else {
            cfg.submitting = true
            resolve(false)
          }
        })
      },
      submit (cfg, thisVue) {
        return new Promise((resolve) => {
          if (typeof cfg.apiMethod === 'function') {
            cfg.apiMethod(cfg.handleSubmitData()).then((res) => {
              tool.wrapResponse(res).then(() => {
                if (cfg.successTip) {
                  thisVue.$notification.success({
                    message: cfg.successTip
                  })
                }
                resolve(res)
                cfg.visible = false
                cfg.submitting = false
              }).catch(() => {
                thisVue.$message.error(tool.getResponseError(res))
                cfg.submitting = false
              })
            })
          } else {
            cfg.submitting = false
            cfg.visible = false
            resolve()
          }
        })
      },
      checkAndSubmit (cfg, form, thisVue) {
        return new Promise((resolve) => {
          this.check(cfg, form).then((isError) => {
            if (!isError) {
              this.submit(cfg, thisVue).then((res) => {
                resolve(res)
              })
            }
          })
        })
      }
    }
  }
}
